import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { NavigationService } from '@unity/services/navigation.service';
import { SessionService } from '@unity/services/session.service';
import { UnityRouteUrlTrees } from '@unity/utils/types';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private readonly sessionService = inject(SessionService);
  private readonly navigationService = inject(NavigationService);

  private loggedInGuard(state: RouterStateSnapshot): boolean {
    const loggedIn = this.sessionService.$isLoggedIn();

    if (!loggedIn) {
      this.sessionService.logout({ returnUrl: [state.url] as UnityRouteUrlTrees });
      return false;
    }
    return true;
  }

  private get activeAccountGuard(): boolean {
    const isActive = this.sessionService.$isActive();
    if (!isActive) {
      this.navigationService.navigate(['/pending']);
      return false;
    }
    return true;
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.loggedInGuard(state) && this.activeAccountGuard) {
      return true;
    }
    return false;
  }
}
